import { CookieConsentProvider } from '@use-cookie-consent/react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Helmet } from 'react-helmet';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ApolloCookieConsent from './components/ApolloCookieConsent';
import ResolvePage from './ResolvePage';
import TeamDetail from '../views/team/TeamDetail';
import CaseDetail from '../views/case/CaseDetail';
import ServiceDetail from '../views/service/ServiceDetail';
import Redirect from '../components/Redirect';
import { useEffect } from 'react';

export default function Apollo() {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={process.env.MIX_REACT_APP_RECAPTCHA}>
            <BrowserRouter>
                <CookieConsentProvider>
                    <Helmet>
                        <title>{process.env.MIX_REACT_APP_APP_NAME}</title>
                    </Helmet>

                    <Routes>
                        <Route path="/">
                            <Route path="werken-bij" element={<Redirect url="https://werkenbijbandwerk.nl/" />} />

                            <Route index element={<ResolvePage />} />
                            {/* Framework routes */}
                            <Route path="medemerkers/:name" element={<TeamDetail />} />
                            <Route path="succesverhalen/:name" element={<CaseDetail />} />

                            <Route path="onze-diensten/:category" element={<ServiceDetail />} />
                            <Route path="onze-diensten/:category/:name" element={<ServiceDetail />} />

                            <Route path=":path">
                                <Route path=":id" element={<ResolvePage />} />
                                <Route path=":id/:urlTitle" element={<ResolvePage detailPage />} />
                                <Route index element={<ResolvePage />} />
                            </Route>
                        </Route>
                    </Routes>
                    <ApolloCookieConsent />
                </CookieConsentProvider>
            </BrowserRouter>
        </GoogleReCaptchaProvider>
    );
}
